import { getFormattedThousand } from "@datassential/platform-ui-lib";
import { FC, memo } from "react";
import { components } from "@api/api";
import HighlightTable from "@pages/ItemDetails/parts/CardOpenEndedFeedback/HighlightTable";

export type Highlight = components['schemas']['NameValueModel'];

const HighlightExperience: FC<{
    likes: Highlight[];
    dislikes: Highlight[];
    baseSize: number;
}> = ({
    likes,
    dislikes,
    baseSize,
}) => {
    return (
        <div className="CardOpenEndedFeedback__section">
            <div className="CardOpenEndedFeedback__section-header">
                <span className="CardOpenEndedFeedback__section-title">
                    HIGHLIGHTING EXERCISE
                </span>
                <span className="CardOpenEndedFeedback__section-subtitle">
                    (n={getFormattedThousand(baseSize)})
                </span>
            </div>
            <div
                className="CardOpenEndedFeedback__section-content"
                style={{ height: 165 }}
            >
                <HighlightTable items={likes} isLike />
                <div className="CardOpenEndedFeedback__separator"/>
                <HighlightTable items={dislikes} />
            </div>
        </div>
    );
};

export default memo(HighlightExperience);